





































    import has from 'lodash/has';
    import { Component, Prop } from 'vue-property-decorator';
    import { showPopup } from '../directives/popup';
    import { dataLayer } from '../globals';
    import Contact from '../models/Contact';
    import BaseComponent from './Base';
    import Captcha from './Recaptcha';

    @Component({
    components: {
        Captcha,
    },
})
export default class ContactForm extends BaseComponent {
    @Prop({ type: String, default: 'Contact Form' }) protected readonly gtmCategory: string;

    protected loading: boolean = false;
    protected validate: boolean = false;
    protected captchaResponse: any = null;
    protected contact = new Contact();

    protected errors: { [key: string]: string } = {
        name: '',
        from: '',
        message: '',
    };

    protected captcha: { title: string, key: string } = {
        title: '',
        key: '',
    };

    protected async onSubmit(): Promise<boolean> {
        this.loading = true;
        this.validate = true;
        try {
            if (await this.validateContact()) {
                const response = await this.contact.save(this.captchaResponse);
                if (!response.success && has(response, 'body.key') && has(response, 'body.title')) {
                    this.captcha = response.body;
                } else {
                    this.captcha.key = '';
                    this.successPopup();
                    dataLayer.push({
                        eventAction: 'Sent',
                        eventCategory: this.gtmCategory,
                        event: 'contactForm:sent',
                    }, {
                      event: 'form_contact',
                      form_name: this.contact.name,
                      form_email: this.contact.from,
                      form_phone: this.contact.phone,
                    });
                    this.contact.clear();
                }
            }
        } catch (e) {
            console.warn(e);
            this.errorPopup(e);
        }
        this.loading = false;
        return true;
    }

    protected onCaptchaResponse(captchaResponse: any): void {
        this.captchaResponse = captchaResponse;
        this.captcha.title = '';
    }

    protected async validateContact(): Promise<boolean> {
        if (!this.validate) {
            return true;
        }
        const errors = {
            name: '',
            from: '',
            message: '',
        };
        try {
            await this.contact.validate();
            this.errors = errors;
            return true;
        } catch (e) {
            this.contact.collectErrors().forEach((collection) => {
                collection.path.forEach((elName) => {
                    errors[elName] = collection.errors.map((error) => error.message).join('<br>');
                });
            });
            this.errors = errors;
            return false;
        }
    }

    protected mounted(): void {
        this.$watch('contact', this.validateContact, { deep: true });
    }

    protected successPopup(): void {
        const oppNr = '';
        const popup = {
            template: `
            <div class="v-modal c-notification">
                <div class="v-modal__close" slot="top-right">
                    <button class="v-modal__close-button" @click="$emit('close')">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg>
                    </button>
                </div>
                <div class="v-modal__content">
                    <h3 class="u-text-center u-text-success" v-text="message"></h3>
                </div>
            </div>`,
            props: ['message'],
        };

        showPopup(popup,
            {
                message: this.t('Your message was sent successfully. Thanks.'),
            },
            {
                width: 640,
                height: '30%',
                // clickToClose: false,
                adaptive: true,
                scrollable: true,
                pivotY: 0.3,
            },
        );
    }

    protected errorPopup(errors): void {
        const oppNr = '';
        const popup = {
            template: `
            <div class="v-modal c-notification">
                <div class="v-modal__close" slot="top-right">
                    <button class="v-modal__close-button" @click="$emit('close')">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg>
                    </button>
                </div>
                <div class="v-modal__content">
                    <strong v-for="error in errors" class="u-text-center u-text-danger" v-text="error.message"></strong>
                </div>
            </div>`,
            props: ['errors'],
        };

        showPopup(popup,
            {
                errors,
            },
            {
                width: 640,
                height: '30%',
                // clickToClose: false,
                adaptive: true,
                scrollable: true,
                pivotY: 0.3,
            },
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContactForm.vue